<template lang="html">
  <div class="buttons">
    <Button v-for="(button, i) in buttons" :key="`button_${i}`" v-bind="button" />
  </div>
</template>

<script>
import Button from '@/components/partials/Button'

export default {
  components: {
    Button
  },
  props: {
    buttons: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.buttons {
  margin: $padding;
}
</style>
